<template>
  <div>
    <div class="download-tab">
      <ul class="nav nav-tabs" id="myTab">
        <li>
          <router-link :to="{ name: 'download' }">
            <i class="iconfont icon-windows"></i>
            <span class="client-name">Windows</span>
          </router-link>
        </li>
        <li class="active">
          <a>
            <i class="iconfont icon-android"></i>
            <span class="client-name">Android</span>
          </a>
        </li>
        <li>
          <router-link :to="{ name: 'downloadIphone' }">
            <i class="iconfont icon-ios1"></i>
            <span class="client-name">iPhone/iPad</span>
          </router-link>
        </li>
        <!-- <li>
          <router-link :to="{ name: 'downloadWindowsSync' }">
            <i class="iconfont icon-windows-tb"></i>
            <span class="client-name">Windows同步端(测试版)</span>
          </router-link>
        </li> -->
        <!-- <li>
          <router-link :to="{ name: 'downloadIphoneSync' }">
            <i class="iconfont icon-ios-tb"></i>
            <span class="client-name">Mac同步端</span>
          </router-link>
        </li> -->
      </ul>
    </div>
    <div class="download clearfix">
      <div class="tab-content" id="myTabContent">
        <div class="tab-pane fade in active" id="pc">
          <div class="pic">
            <img src="@/assets/images/dbg-az.png" />
          </div>
          <div class="detail">
            <h1>睿客云盘Android版</h1>
            <h2>
              1TB超大存储空间，
              <br />手机相册、视频 一键备份到云盘
            </h2>
            <div class="btnbox">
              <button
                class="btn btn-primary"
                type="button"
                @click="downloadInstall"
              >
                下载Android版
              </button>
              <div class="code">
                <qrcode-vue
                  :value="releases.download_install"
                  v-if="releases.download_install"
                  :size="130"
                  level="H"
                ></qrcode-vue>
                <p>使用手机扫描二维码，直接下载睿客云盘。</p>
              </div>
            </div>
            <div class="info">
              <ul>
                <li>适应系统：Android 4.4及以上版本</li>
                <li>更新时间：{{ this.releases.released_at }}</li>
                <li>
                  版本：{{ this.releases.version_no }}
                  <router-link :to="{ name: 'updatelogAndroid' }"
                    >查看详细</router-link
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QrcodeVue from "qrcode.vue";
import { clientReleases } from "@/api/common/index";
export default {
  name: "Download",
  components: {
    QrcodeVue,
  },
  data() {
    return {
      releases: {
        terminal_name: "",
        download_install: "",
        download_unzip: "",
        created_at: "",
        version_no: "",
      },
    };
  },
  created() {
    this.$store.commit("SET_THEME", "客户端下载");
    this.clientReleases();
  },
  methods: {
    // 获取PC版本等信息
    clientReleases() {
      clientReleases({
        offset: 0,
        limit: 1,
        terminal_type: "4",
      })
        .then((res) => {
          if (res.status_code === 200) {
            this.releases = res.entity[0];
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    // 下载安装包
    downloadInstall() {
      window.location.href = this.releases.download_install;
    },
  },
};
</script>

<style scoped>
</style>